import { rootApi } from 'root-api'

import { CONTACT_BY_EMAIL_QUERY, CONTACTS_BY_IDS_QUERY } from './constants'

const oapApiGraphqlBaseUrl = '/api/oap-api/graphql'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['CONTACT'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchContactByEmailGQL: build.query({
      query: (email) => ({
        url: oapApiGraphqlBaseUrl,
        method: 'POST',
        data: {
          query: CONTACT_BY_EMAIL_QUERY,
          variables: { email }
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      transformResponse: (res) => res?.data?.contactByEmail,
      providesTags: ['CONTACT']
    }),
    fetchContactsByIdsGQL: build.query({
      query: (variables) => ({
        url: oapApiGraphqlBaseUrl,
        method: 'POST',
        data: {
          query: CONTACTS_BY_IDS_QUERY,
          variables,
        },
      }),
      extraOptions: {
        handleErrors: false,
        transformRequest: false,
      },
      transformResponse: (res) => res?.data,
      providesTags: ['CONTACT']
    }),
  })
})

export const {
  useFetchContactByEmailGQLQuery,
  useFetchContactsByIdsGQLQuery,
} = api
